// extracted by mini-css-extract-plugin
module.exports = {"emblaSlideItem":"PSVVnryBZ_zstjnY7_3Yd"};